import { withRouter, Link } from 'react-router-dom';
import React from 'react';
import { BaseListContainer } from 'containers/BaseContainer/BaseListContainer';
import { getList, exportData } from 'api/biodiversityApi';
import slug from 'constants/slug';
import styled from 'styled-components';
import { createForm } from 'rc-form';
import PageLockHOC from 'hoc/pageLock';
import { get } from 'lodash';
import SearchForm from './SearchForm';
import Maps from './Maps';
import { COLOR } from 'config';

const NameContainer = styled.div`
  color: ${COLOR.SECOND_COLOR};
  text-decoration: underline;
`;

@PageLockHOC(['biodiversity.view'])
class BiodiversityList extends BaseListContainer {
  constructor(props) {
    const funcApi = {
      getList: async (...args) => {
        const res = await getList(...args);
        const {
          data: { list: data, areas },
        } = res;
        this.setState({ areas }, () => {
          if (this.mapRef) this.mapRef.createClusters()
        })
        return { ...res, data };
      },
    };

    const columns = [
      {
        dataField: 'ProjectName',
        text: 'Tên dự án',
        formatter: (cell, row) => {
          return (
            <Link
              to={slug.BIODIVERSITY.DETAIL_WITH_ID + row._id}
              target='_blank'
            >
              <NameContainer style={{ width: 200 }}>{cell}</NameContainer>
            </Link>
          );
        },
      },
      {
        dataField: 'NumberDoc',
        text: (
          <div>
            Số văn bản
            <br />
            (quyết định/báo cáo)
          </div>
        ),
        formatter: (cell) => {
          return <div style={{ width: 120 }}>{cell}</div>;
        },
      },
      {
        dataField: 'ReportYear',
        text: 'Năm báo cáo',
        formatter: (cell) => {
          return <div style={{ width: 120 }}>{cell}</div>;
        },
      },
      {
        dataField: 'ResultsManagementAgency',
        text: 'Cơ quan phê duyệt',
        formatter: (cell) => {
          return <div>{cell}</div>;
        },
      },
      {
        dataField: 'Agency',
        text: 'Cơ quan chủ quản',
        formatter: (cell) => {
          return <div>{cell}</div>;
        },
      },
      {
        dataField: 'Admisnistor',
        text: 'Cơ quan chủ trì',
        formatter: (cell) => {
          return <div>{cell}</div>;
        },
      },
      {
        dataField: 'Notes',
        text: 'Ghi chú',
        formatter: (cell) => {
          return <div>{cell}</div>;
        },
      },
    ];
    super(
      props,
      funcApi,
      columns,
      slug.BIODIVERSITY.CREATE,
      'biodiversity',
      {},
      false,
      false,
      true
    );

    this.state = {
      ...this.state,
      showChart: false,
    };
  }

  handleSearch = () => {
    const { form } = this.props;

    const values = form.getFieldsValue();
    const params = {
      ProjectName: get(values, 'ProjectName'),
      SpeciesName: get(values, 'SpiciesName.value'),
      SpeciesType: get(values, 'SpiciesType.value'),
      ReportYear: get(values, 'ReportYear.value'),
    };
    super.handelSubmitSearch(params);
  };

  renderSearchContainer() {
    const { form } = this.props;
    const { toogleMap } = this.state;

    return (
      <SearchForm
        form={form}
        handleExport={this.handleExport}
        handleSearch={this.handleSearch}
        handleToogleMap={this.handleToogleMap}
        toogleMap={toogleMap}
      />
    );
  }

  handleExport = async (type) => {
    const { form } = this.props;
    const values = form.getFieldsValue();
    const params = {
      type,
      ProjectName: get(values, 'ProjectName'),
      SpeciesName: get(values, 'SpiciesName.value'),
      SpeciesType: get(values, 'SpiciesType.value'),
      ReportYear: get(values, 'ReportYear.value'),
    };

    const results = await exportData(params);
    const dataBuff = toArrayBuffer(results.buffer.data);
    const blob = new Blob([dataBuff], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    getFile(blob, results.fileName);
  };

  handleToogleMap = () => {
    this.setState(({ toogleMap }) => ({ toogleMap: !toogleMap }));
    if (this.mapRef) this.mapRef.createClusters()
  }

  renderDataTable() {
    const { toogleMap, areas } = this.state;
    if (!toogleMap) return super.renderDataTable();
    return <Maps data={areas} ref={ref => this.mapRef = ref}/>;
  }
}

export default withRouter(createForm()(BiodiversityList));



// WEBPACK FOOTER //
// ./src/containers/Biodiversity/BiodiversityList/index.js